<template>
  <div id="app">
    <keep-alive :include="cachedRoutes">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import VConsole from 'vconsole';
import {hideShareMenus} from '@/utils/wxApi'
import { noLoginPages } from '@/utils/constant'
export default {
  name: 'App',
  provide: function () {
    return {
      reload: this.reload,
    }
  },
  data: function () {
    return {
      isRouterAlive: true,
      cachedRoutes: ['activityRecharge']
    }
  },
  watch: {
    $route(to, from) {
      this.handleKeepAlive(to, from);
      if (noLoginPages.includes(to.name)) {
        return
      }
      if (to !== from) {
        // TODO
        this.handleWXMenus();
      }
    }
  },
  methods: {
    reload: function () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    handleWXMenus() {
      hideShareMenus();
    },
    handleKeepAlive(to, from) {
      if (to.meta.keepAlive && !this.cachedRoutes.includes(to.name)) {
        this.cachedRoutes.push(to.name);
      }

      if (from.meta.keepAlive && to.meta.deepth &&  from.meta.deepth && to.meta.deepth < from.meta.deepth) {
        const index = this.cachedRoutes.indexOf(from.name);
        index > -1 && this.cachedRoutes.splice(index, 1);
      }
    }
  },
  mounted() {
    if (process.env.BUILD_ENV === 'dev' || process.env.VUE_APP_BUILD_ENV === 'uat') {
      new VConsole();
    }
  }
}
</script>
